import { atom } from "jotai";

export const showJotaiDevToolsAtom = atom(false);
showJotaiDevToolsAtom.debugLabel = "showJotaiDevToolsAtom";
